import { useAsyncFn } from 'react-use';

import GetOrg2FAPolicy from './api';
import { TResponseGetOrg2FAPolicy } from './type';
import { useCommonActionFromDALV2 } from '@shares/actionFormDALV2';

export type TUseGetOrg2FAPolicy = {
  isLoading: boolean;
  response?: TResponseGetOrg2FAPolicy;
  handleGetOrg2FAPolicy: () => Promise<TResponseGetOrg2FAPolicy | undefined>;
};

const useGetOrg2FAPolicy = (): TUseGetOrg2FAPolicy => {
  const commonActionFromDALV2 = useCommonActionFromDALV2();

  const [state, doFetch] = useAsyncFn(async () => {
    const response: Promise<TResponseGetOrg2FAPolicy> = commonActionFromDALV2(GetOrg2FAPolicy);
    const result = await response;
    return result;
  }, []);

  return {
    isLoading: state.loading,
    response: state?.value,
    handleGetOrg2FAPolicy: doFetch,
  };
};

export default useGetOrg2FAPolicy;
